import React from 'react';
import GphRichBlock from '../GphRichBlock';
import { CAPABILITIES } from '../../../services/gph/gphCapabilityRegistry';
import { describeUsage } from '../../../services/gph/gphFreeUsagePolicy';

// Plano, limites por skill e acessos vitalícios legados — dentro da conversa.
export default function ProfilePlanAdapter({ agent }) {
  const { host } = agent;
  const entitlements = host.entitlements || {};
  const isPro = entitlements.isPro === true;

  const freeLimitedCaps = Object.values(CAPABILITIES)
    .filter((cap) => cap.requiresPlan === 'free_limited');

  return (
    <GphRichBlock eyebrow="Plano" title="SEU PLANO E LIMITES">
      <dl className="gph-kv">
        <div><dt>Plano atual</dt><dd>{agent.planLabel}</dd></div>
        {entitlements.calculatorLifetime && (
          <div><dt>Acesso vitalício</dt><dd>Calculadora PUBG (compra antiga preservada)</dd></div>
        )}
        {entitlements.freefireCalculatorLifetime && (
          <div><dt>Acesso vitalício</dt><dd>Calculadora Free Fire (compra antiga preservada)</dd></div>
        )}
      </dl>

      {!isPro && (
        <div className="gph-plan-limits">
          <h4 className="gph-drill-section__label">Limites Free por skill</h4>
          <ul className="gph-block-list gph-block-list--compact">
            {freeLimitedCaps.map((cap) => {
              const usage = describeUsage(agent.usage, cap);
              return (
                <li key={cap.capabilityId}>
                  {cap.friendlyName}: {usage ? `${usage.remaining} de ${usage.limit} usos restantes` : 'disponível'}
                </li>
              );
            })}
            <li>Calcular miras: exclusivo Pro{(entitlements.calculatorLifetime || entitlements.freefireCalculatorLifetime) ? ' (você mantém a calculadora comprada)' : ''}</li>
          </ul>
        </div>
      )}

      <div className="gph-block-actions">
        {!isPro && (
          <button
            type="button"
            className="gph-btn gph-btn--primary"
            onClick={() => agent.runCapability('purchase_pro', {})}
          >
            Conhecer o Pro
          </button>
        )}
        <button
          type="button"
          className="gph-btn gph-btn--ghost"
          onClick={() => agent.runCapability('profile_settings', {})}
        >
          Gerenciar conta{isPro ? ' e assinatura' : ''}
        </button>
      </div>
    </GphRichBlock>
  );
}
